import { normalizeBaseUrl } from "shared-utils";
import { Api as CastingMediaApi } from "../generated/CastingMediaApi";
import config from "../config";
import { createAxiosRequestInterceptors } from "../axios/axios-interceptors";

const castingMediaApi = new CastingMediaApi({
  baseURL: normalizeBaseUrl(config.castingMediaApiUrl),
});

createAxiosRequestInterceptors(castingMediaApi.instance);

export default castingMediaApi;
